import { render, staticRenderFns } from "./SocialSection.vue?vue&type=template&id=98ba4e2e&scoped=true&"
import script from "./SocialSection.vue?vue&type=script&lang=js&"
export * from "./SocialSection.vue?vue&type=script&lang=js&"
import style0 from "./SocialSection.vue?vue&type=style&index=0&id=98ba4e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ba4e2e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SingleSocialPost: require('/app/components/SingleSocialPost.vue').default})
